

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import './i18n';
// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/react-demo.css";
// pages
import Presentation from "views/Presentation.js";
import AboutUs from "views/examples/AboutUs.js";
import BlogPost from "views/examples/BlogPost.js";
import BlogPost2 from "views/examples/BlogPost2.js";
import BlogPost3 from "views/examples/BlogPost3.js";
import BlogPost4 from "views/examples/BlogPost4.js";
import BlogPost5 from "views/examples/BlogPost5.js";
import BlogPost6 from "views/examples/BlogPost6.js";
import ContactUs from "views/examples/ContactUs.js";
import Discover from "views/examples/Discover.js";
// others

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/home" element={<Presentation />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/chivatour" element={<BlogPost />} />
      <Route path="/playablanca" element={<BlogPost2 />} />
      <Route path="/cuatroislas" element={<BlogPost3 />} />
      <Route path="/gentedemar" element={<BlogPost4 />} />
      <Route path="/palmarito" element={<BlogPost5 />} />
      <Route path="/bahia" element={<BlogPost6 />} />

      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/gallery" element={<Discover />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  </BrowserRouter>
);
